import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

export default styled(Flexer.Parent).attrs(() => ({ p: 'XS', pLeft: 'S', pRight: 'S' }))`
  border-bottom: 1px solid var(--greyMouse);
`;
